import React from 'react';

interface HealthEditFormFieldsProps {
  adminFee: number | string;
  setAdminFee: (val: number | string) => void;
  piso: number | string;
  setPiso: (val: number | string) => void;
  ascensor: string;
  setAscensor: (val: string) => void;
  estrato: number | string;
  setEstrato: (val: number | string) => void;
  antiguedad: number | string;
  setAntiguedad: (val: number | string) => void;
  area: number | string;
  setArea: (val: number | string) => void;
  lat: number | string;
  setLat: (val: number | string) => void;
  lng: number | string;
  setLng: (val: number | string) => void;
}

export const HealthEditFormFields: React.FC<HealthEditFormFieldsProps> = ({
  adminFee,
  setAdminFee,
  piso,
  setPiso,
  ascensor,
  setAscensor,
  estrato,
  setEstrato,
  antiguedad,
  setAntiguedad,
  area,
  setArea,
  lat,
  setLat,
  lng,
  setLng,
}) => {
  return (
    <div className="grid grid-cols-2 gap-3 text-xs">
      <div>
        <label className="block font-bold text-gray-600 mb-1">Valor Administración ($)</label>
        <input
          type="number"
          value={adminFee}
          onChange={(e) => setAdminFee(e.target.value)}
          placeholder="Ej. 250000"
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
      <div>
        <label className="block font-bold text-gray-600 mb-1">Número de Piso</label>
        <input
          type="text"
          value={piso}
          onChange={(e) => setPiso(e.target.value)}
          placeholder="Ej. 3, 4, PB"
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
      <div>
        <label className="block font-bold text-gray-600 mb-1">Cantidad de Ascensores</label>
        <input
          type="number"
          min="0"
          value={ascensor}
          onChange={(e) => setAscensor(e.target.value)}
          placeholder="0 (Sin ascensor) o 1, 2..."
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
      <div>
        <label className="block font-bold text-gray-600 mb-1">Estrato (1 a 6)</label>
        <input
          type="number"
          min="1"
          max="6"
          value={estrato}
          onChange={(e) => setEstrato(e.target.value)}
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
      <div>
        <label className="block font-bold text-gray-600 mb-1">Antigüedad (Años)</label>
        <input
          type="number"
          min="0"
          value={antiguedad}
          onChange={(e) => setAntiguedad(e.target.value)}
          placeholder="Ej. 5"
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
      <div>
        <label className="block font-bold text-gray-600 mb-1">Área Construida (m²)</label>
        <input
          type="number"
          value={area}
          onChange={(e) => setArea(e.target.value)}
          placeholder="Ej. 65"
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
      <div>
        <label className="block font-bold text-gray-600 mb-1">Latitud</label>
        <input
          type="number"
          step="any"
          value={lat}
          onChange={(e) => setLat(e.target.value)}
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
      <div>
        <label className="block font-bold text-gray-600 mb-1">Longitud</label>
        <input
          type="number"
          step="any"
          value={lng}
          onChange={(e) => setLng(e.target.value)}
          className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-sky-500 outline-none font-semibold"
        />
      </div>
    </div>
  );
};
